<template>
  <div class="error">
    <h3 class="text">您没权限访问该页面或者该页面不存在！</h3>
  </div>
</template>

<script>
export default {
  name: 'Error'
};
</script>

<style lang="scss" scoped>
.text{
  padding: 35px 0;
  text-align: center;
  font-size: 20px;
  font-weight: normal;
}
</style>

